<script setup lang="ts">
import HugeIcon from '../HugeIcon/HugeIcon.vue';
import ButtonV2 from '../ButtonV2/ButtonV2.vue';
import type { Icon } from '../HugeIcon/huge-icon';
import type { ButtonV2Variants } from '../ButtonV2/button-v2';

const props = defineProps<{
  title?: string;
  description?: string;
  icon?: Icon;
  action?: {
    actionLabel: string;
    actionIcon?: Icon;
    actionVariant?: ButtonV2Variants;
  };
}>();

const emits = defineEmits<{
  action: [];
}>();

const handleAction = () => {
  emits('action');
};
</script>

<template>
  <div
    class="flex flex-col items-center justify-center gap-4 rounded-lg border border-slate-200 bg-slate-50 p-8 text-center"
  >
    <div
      v-if="props.icon"
      class="flex h-20 w-20 items-center justify-center rounded-full bg-gradient-to-br from-slate-100 to-slate-200"
    >
      <HugeIcon :icon="props.icon" :size="48" class="text-slate-400" />
    </div>

    <div class="flex flex-col gap-2">
      <h3
        v-if="props.title || $slots.title"
        class="text-lg font-semibold text-slate-800"
      >
        {{ props.title }}
      </h3>

      <div
        v-if="props.description || $slots.description"
        class="max-w-md text-sm text-slate-600"
      >
        <slot name="description">
          <p>{{ props.description }}</p>
        </slot>
      </div>
    </div>

    <slot />

    <div v-if="props.action" class="mt-2">
      <ButtonV2
        :label="props.action.actionLabel"
        :icon="props.action.actionIcon"
        :variant="props.action.actionVariant"
        @click="handleAction"
      />
    </div>
  </div>
</template>
